// AIDEV-NOTE: Admin status is now included in user details to reduce API calls
import { useUserDetails } from "./queries/use-user-details";

export const useIsAdmin = () => {
    const { data: userDetails, isLoading, error } = useUserDetails();

    return {
        data: userDetails?.isAdmin ?? false,
        isLoading,
        isError: !!error,
        error,
    };
};
